export const CARD = 'card'
export const ACH = 'ach'

export const ALL_PAYMENT_METHODS = [CARD, ACH]

export const PAYMENT_METHOD_OPTIONS = [
  { value: 'both', label: 'Card and bank account', methods: [CARD, ACH] },
  { value: 'ach', label: 'Bank account only', methods: [ACH] },
  { value: 'card', label: 'Card only', methods: [CARD] },
]

export const acceptedMethodsOf = (value) => {
  if (!Array.isArray(value)) return ALL_PAYMENT_METHODS
  const valid = ALL_PAYMENT_METHODS.filter((method) => value.includes(method))
  return valid.length > 0 ? valid : ALL_PAYMENT_METHODS
}

export const acceptsCard = (value) => acceptedMethodsOf(value).includes(CARD)

export const acceptsAch = (value) => acceptedMethodsOf(value).includes(ACH)

export const defaultMethodOf = (value) => (acceptsAch(value) ? ACH : CARD)

export const optionValueOf = (methods) => {
  const accepted = acceptedMethodsOf(methods).join()
  const option = PAYMENT_METHOD_OPTIONS.find((candidate) => candidate.methods.join() === accepted)
  return option ? option.value : PAYMENT_METHOD_OPTIONS[0].value
}
